import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import { CLEAN_DOWNLOAD_COMPETENCIA_STATE, CLEAN_IMPORTACAO_STATE, ON_DOWNLOAD_COMPETENCIA_STATE, ON_IMPORTACAO_STATE } from "../../actionTypes";
import { getToken } from "./authActions";

export function hubConnection(route) {
  const connection = new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_SIGNALR_URL}/${route}`, {
      transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
      "content-type": "application/json",
      accessTokenFactory: getToken,
    })
    .withAutomaticReconnect()
    .build();

  connection.start().catch((err) => console.log(err.toString()));

  return connection;
}

export function onImportacaoState(connection) {
  return (dispatch) => {
    connection.on("Mensagens_Importacao", async (data) => {
      await dispatch({
        type: ON_IMPORTACAO_STATE,
        payload: data,
      });
      await dispatch({ type: CLEAN_IMPORTACAO_STATE });
    });
  };
}

export function onDownloadCompetenciasState(connection) {
  return (dispatch) => {
    connection.on("Mensagens__DownloadCompetencias", async (data) => {
      await dispatch({
        type: ON_DOWNLOAD_COMPETENCIA_STATE,
        payload: data,
      });
      await dispatch({ type: CLEAN_DOWNLOAD_COMPETENCIA_STATE });
    });
  };
}
